import { TTariffsGroup } from '~/src/features/request/types/TTariffsGroup';

const getUriToFullBuy = (alias: string, tariffsGroup: TTariffsGroup) => {
    return `/full-buy?tariffName=${alias}&monoTariff=${tariffsGroup === 'internet'}`;
};

export default getUriToFullBuy;
